export default __webpack_public_path__ + "static/media/seville-jump.9e3bce35.jpg";